





















































import { Component, Prop } from 'vue-property-decorator';
import { GoalModel, GoalValueType, IGoal, IUser } from 'admiral-core';
import { CalendarIcon, CircleIcon, DiscIcon, XIcon } from 'vue-feather-icons';
import Multiselect from 'vue-multiselect';
import PolicyTimeline from '@/views/pages/policies/PolicyTimeline.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import PolicySelect from '@/components/common/selects/PolicySelect.vue';
import UserSelect from '@/components/common/selects/UserSelect.vue';
import TaskForm from '@/forms/TaskForm.vue';
import { FormMixin } from '@/mixins/FormMixin';
import { BModal } from 'bootstrap-vue';
import GoalForm from '@/forms/GoalForm.vue';
import { GoalApi } from '@/services/GoalApi';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

@Component({
  components: {
    GoalForm,
    TaskForm,
    UserSelect,
    PolicySelect,
    PolicyTimeline,
    CircleIcon,
    DiscIcon,
    Multiselect,
    CalendarIcon,
    XIcon,
  },
})
export default class CreateGoalModal extends mixins(BaseMixin, FormMixin) {
  @Prop({ required: false, type: String, default: 'agency' })
  readonly type!: IGoal['type'];

  @Prop({ required: false, type: Object })
  readonly selectedUser!: IUser;

  @Prop({ required: false, type: Array, default: [] })
  readonly usersOptions!: IUser[];

  model = this.defaultModel();

  defaultModel(): GoalModel {
    return {
      name: '',
      type: this.$route.meta.type,
      user: this.selectedUser,
      valueType: GoalValueType.Valuation,
      policyType: 'all',
    };
  }

  async mounted() {
    this.$nextTick(() => {
      this.model = { ...this.defaultModel() };
    });
  }

  async ok(evt: Event) {
    evt.preventDefault();

    try {
      this.isLoading = true;
      const response = await GoalApi.create({
        name: this.model.name!,
        user: this.model.user!,
        from: dayjs(this.model.from!).utc(true).startOf('day').toDate(),
        to: dayjs(this.model.to!).utc(true).endOf('day').toDate(),
        type: this.$route.meta.type,
        valueType: this.model.valueType!,
        value: Number(this.model.value!),
        products: this.model.products!,
        agency: this.agency,
        policyType: this.model.policyType,
      });
      this.model = { ...this.defaultModel() };
      this.$emit('reload');
      this.$nextTick(() => {
        (this.$refs['create-goal'] as BModal).hide();
      });
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);

      this.errorHandling(apiErrors);
      this.$toastr.e('Beim Speichern der Aufgabe ist etwas schief gelaufen.', 'Oops');
      throw e;
    } finally {
      this.isLoading = false;
    }
  }

  errorHandling(apiErrors: Record<string, string>) {
    this.addError(apiErrors['nameisNotEmpty'], 'name', 'Bitte einen Ziel Namen eingeben angeben.');
    this.addError(apiErrors['valueisNumber'], 'value', 'Bitte einen numerischen Zielwert angeben.');
    this.addError(apiErrors['valueisNotEmpty'], 'value', 'Bitte einen Zielwert angeben.');

    this.addError(apiErrors['fromisNotEmpty'], 'from', 'Bitte ein gültiges Startdatum wählen.');
    this.addError(apiErrors['fromisDateString'], 'from', 'Bitte ein gültiges Startdatum wählen.');

    this.addError(apiErrors['fromisNotEmpty'], 'to', 'Bitte ein gültiges Enddatum wählen.');
    this.addError(apiErrors['fromisDateString'], 'to', 'Bitte ein gültiges Enddatum wählen.');

    this.addError(
      apiErrors['productsisNotEmpty'],
      'products',
      'Bitte mindestens ein Produkt auswählen.',
    );
  }

  async cancel() {
    this.model = { ...this.defaultModel() };
  }
}
